export default __webpack_public_path__ + "static/rs-bd9ca241a8c8abfc20288d8d62005c17.svg";